export default "__VITE_ASSET__Bd8UtcPO__"